import React from "react";
import styles from "./LocationTableHeader.module.css";

export const LocationTableHeader: React.FC = () => {

    return <div className={styles.wrapper}>
        <span className={styles.locationIdCell}>Location ID</span>
        <span className={styles.nameCell}>Name</span>
        <span className={styles.cityCell}>City</span>
        <span className={styles.postcodeCell}>Postcode</span>
        <span className={styles.actionsCell}>Actions</span>
    </div>
}
